import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Logger, ApiValidation } from 'src/app/@shared';
import { DEFAULT_SNACKBAR_CONFIG } from 'src/app/@shared/constants/site.constants';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { Asset, AssetsService, AssetGroup, AssetTag, AssetTagService, UploadAssetsProductsComponent, UploadAssetsOffersComponent, UploadAssetsEventsComponent, UploadAssetsPromosComponent, UploadAssetsOfferGroupsComponent, UploadAssetsVersionsComponent, OfferTag, OfferTagService } from '../..';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { HttpEventType } from '@angular/common/http';
import { UploadAssetsProductBrandsComponent } from '../../components/upload-assets-product-brands/upload-assets-product-brands.component';
import { AuthorizeControlService } from 'pr1-ui-components';

const log = new Logger('UploadAssetsComponent');
export interface Tag {
  name: string;
}
@Component({
  selector: 'app-upload-assets',
  templateUrl: './upload-assets.component.html',
  styleUrls: ['./upload-assets.component.scss']
})

export class UploadAssetsComponent<Tag extends OfferTag, Group extends AssetGroup, ATag extends AssetTag> implements OnInit {
  assetGroups$: AssetGroup[] = [];
  offerTagIds: string[] = [];
  updatedOfferTagIds: string[] = [];
  selectedEvent: any;
  selectedOffer: any;
  selectedVersion: any;
  selectedVersionId: any;
  selectedProduct: any;
  selectedProductBrand: any;
  selectedPromo: any;
  selectedOfferGroup: any;
  showDone!: boolean;
  showButtons = true;
  viewModel$ = combineLatest([
    this.assetsService.assets$,
  ]).pipe(
    map(([assets]) => {
      return {
        assets
      }
    }),
  );
  addOnBlur = true;
  name!: string;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  tags: Tag[] = [];
  uploadAssets: any;
  tagCtrl = new FormControl<string>('', [Validators.minLength(1), Validators.maxLength(50), Validators.pattern("[a-zA-Z0-9 \\-#&*\\'/]*")]);
  selectedFiles: any[] = [];
  selectedGroupName!: AssetGroup;
  progressInfos: any[] = [];
  uploadStatuses: boolean[] = [];

  formGroup = new FormGroup({
    groupName: new FormControl(null, [Validators.required]),
    event: new FormControl(''),
    offer: new FormControl(''),
    version: new FormControl([]),
    product: new FormControl(''),
    productbrand: new FormControl(''),
    promo: new FormControl(''),
    offergroup: new FormControl('')
  });

  constructor(private assetsService: AssetsService<Asset>, private assetTagService: AssetTagService<ATag, AssetGroup>, private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private matSnackBar: MatSnackBar,
    private authorizationService: AuthorizeControlService,
    private offerTagService: OfferTagService<Tag>,) { }

  ngOnInit(): void {
    log.debug('init');
    this.assetTagService.assetGroups$.subscribe({
      next: (data) => {
        let assetGroupTemp: any = [];
        const keys = ['products', 'badges', 'brands'];
        data?.forEach((d) => {
          if (keys.includes(d?.AssetGroupName?.toLowerCase())) {
            if (this.isAdmin()) {
              assetGroupTemp.push(d);
            }
          } else {
            assetGroupTemp.push(d);
          }
        });
        this.assetGroups$ = assetGroupTemp;
      },
    });
    this.formGroup.controls.groupName.valueChanges.subscribe(res => {
      if (res) {
        this.selectedGroupName = res;
        this.updateMandFields(res);
      }
    });

    this.formGroup.controls.event.valueChanges.subscribe(res => {
      this.formGroup.controls.offer.reset();
      this.formGroup.controls.offer.clearValidators();
      this.formGroup.controls.promo.reset();
      this.formGroup.controls.promo.clearValidators();
      this.formGroup.controls.offergroup.reset();
      this.formGroup.controls.offergroup.clearValidators();
      this.formGroup.controls.version.reset();
      this.formGroup.controls.version.clearValidators();
      if (this.selectedGroupName && this.selectedGroupName.AssetGroupName == 'Offers') {
        this.selectedOffer = null;
        this.formGroup.controls.offer.reset();
        this.formGroup.controls.offer.setValidators([Validators.required]);
        this.formGroup.controls.offer.patchValue(null);
      }

      if (this.selectedGroupName && this.selectedGroupName.AssetGroupName == 'Promos') {
        this.selectedPromo = null;
        this.formGroup.controls.promo.reset();
        this.formGroup.controls.promo.setValidators([Validators.required]);
        this.formGroup.controls.promo.patchValue(null);
      }

      if (this.selectedGroupName && this.selectedGroupName.AssetGroupName == 'Offer Groups') {
        this.selectedOfferGroup = null;
        this.formGroup.controls.offergroup.reset();
        this.formGroup.controls.offergroup.setValidators([Validators.required]);
        this.formGroup.controls.offergroup.patchValue(null);
      }

      if (this.selectedGroupName && (this.selectedGroupName.AssetGroupName == 'Versions' || this.selectedGroupName.AssetGroupName == 'Image Maps')) {
        this.selectedVersion = null;
        this.formGroup.controls.version.reset();
        if (this.selectedGroupName && this.selectedGroupName.AssetGroupName == 'Versions') {
          this.formGroup.controls.version.setValidators([Validators.required]);
          this.formGroup.controls.version.patchValue(null);
        }
      }
    });
  }


  private updateMandFields(groupValue: Group) {
    this.selectedEvent = null;
    this.selectedOffer = null;
    this.selectedVersion = null;
    this.selectedProduct = null;
    this.selectedProductBrand = null;
    this.selectedPromo = null;
    this.selectedOfferGroup = null;
    this.formGroup.controls.offergroup.reset();
    this.formGroup.controls.offergroup.clearValidators();
    this.formGroup.controls.offergroup.patchValue('');
    this.formGroup.controls.offergroup.updateValueAndValidity();
    if (groupValue?.AssetGroupName == 'Common' || groupValue?.AssetGroupName == 'Badges') {
      this.formGroup.controls.event.reset();
      this.formGroup.controls.event.clearValidators();
      this.formGroup.controls.event.patchValue('');
      this.formGroup.controls.offer.reset();
      this.formGroup.controls.offer.clearValidators();
      this.formGroup.controls.offer.patchValue('');
      this.formGroup.controls.product.reset();
      this.formGroup.controls.product.clearValidators();
      this.formGroup.controls.product.patchValue('');
      this.formGroup.controls.promo.reset();
      this.formGroup.controls.promo.clearValidators();
      this.formGroup.controls.promo.patchValue('');
      this.formGroup.controls.version.reset();
      this.formGroup.controls.version.clearValidators();
      this.formGroup.controls.version.patchValue([]);
      this.formGroup.controls.productbrand.clearValidators();
      this.formGroup.controls.productbrand.patchValue('');
    } else if (groupValue?.AssetGroupName == 'Events') {
      this.formGroup.controls.event.reset();
      this.formGroup.controls.event.setValidators([Validators.required]);
      this.formGroup.controls.product.clearValidators();
      this.formGroup.controls.product.patchValue('');
      this.formGroup.controls.offer.clearValidators();
      this.formGroup.controls.offer.patchValue('');
      this.formGroup.controls.promo.clearValidators();
      this.formGroup.controls.promo.patchValue('');
      this.formGroup.controls.version.clearValidators();
      this.formGroup.controls.version.patchValue([]);
      this.formGroup.controls.productbrand.clearValidators();
      this.formGroup.controls.productbrand.patchValue('');
    } else if (groupValue?.AssetGroupName == 'Offers') {
      this.formGroup.controls.event.reset();
      this.formGroup.controls.event.setValidators([Validators.required]);
      this.formGroup.controls.offer.reset();
      this.formGroup.controls.offer.setValidators([Validators.required]);
      this.formGroup.controls.product.clearValidators();
      this.formGroup.controls.product.patchValue('');
      this.formGroup.controls.promo.clearValidators();
      this.formGroup.controls.promo.patchValue('');
      this.formGroup.controls.version.clearValidators();
      this.formGroup.controls.version.patchValue([]);
      this.formGroup.controls.productbrand.clearValidators();
      this.formGroup.controls.productbrand.patchValue('');
    } else if (groupValue?.AssetGroupName == 'Promos') {
      this.formGroup.controls.event.reset();
      this.formGroup.controls.event.setValidators([Validators.required]);
      this.formGroup.controls.promo.reset();
      this.formGroup.controls.promo.setValidators([Validators.required]);
      this.formGroup.controls.product.clearValidators();
      this.formGroup.controls.product.patchValue('');
      this.formGroup.controls.offer.clearValidators();
      this.formGroup.controls.offer.patchValue('');
      this.formGroup.controls.version.clearValidators();
      this.formGroup.controls.version.patchValue([]);
      this.formGroup.controls.productbrand.clearValidators();
      this.formGroup.controls.productbrand.patchValue('');
    } else if (groupValue?.AssetGroupName == 'Offer Groups') {
      this.formGroup.controls.event.reset();
      this.formGroup.controls.event.setValidators([Validators.required]);
      this.formGroup.controls.offergroup.reset();
      this.formGroup.controls.offergroup.setValidators([Validators.required]);
      this.formGroup.controls.offergroup.updateValueAndValidity();
      this.formGroup.controls.product.clearValidators();
      this.formGroup.controls.product.patchValue('');
      this.formGroup.controls.offer.clearValidators();
      this.formGroup.controls.offer.patchValue('');
      this.formGroup.controls.promo.clearValidators();
      this.formGroup.controls.promo.patchValue('');
      this.formGroup.controls.version.clearValidators();
      this.formGroup.controls.version.patchValue([]);
      this.formGroup.controls.productbrand.clearValidators();
      this.formGroup.controls.productbrand.patchValue('');
    } else if (groupValue?.AssetGroupName == 'Versions') {
      this.formGroup.controls.event.reset();
      this.formGroup.controls.event.setValidators([Validators.required]);
      this.formGroup.controls.version.reset();
      this.formGroup.controls.version.setValidators([Validators.required]);
      this.formGroup.controls.offer.clearValidators();
      this.formGroup.controls.offer.patchValue('');
      this.formGroup.controls.product.clearValidators();
      this.formGroup.controls.product.patchValue('');
      this.formGroup.controls.promo.clearValidators();
      this.formGroup.controls.promo.patchValue('');
      this.formGroup.controls.productbrand.clearValidators();
      this.formGroup.controls.productbrand.patchValue('');
    } else if (groupValue?.AssetGroupName == 'Image Maps') {
      this.formGroup.controls.event.reset();
      this.formGroup.controls.event.setValidators([Validators.required]);
      this.formGroup.controls.version.clearValidators();
      this.formGroup.controls.version.patchValue([]);
      this.formGroup.controls.offer.clearValidators();
      this.formGroup.controls.offer.patchValue('');
      this.formGroup.controls.product.clearValidators();
      this.formGroup.controls.product.patchValue('');
      this.formGroup.controls.promo.clearValidators();
      this.formGroup.controls.promo.patchValue('');
      this.formGroup.controls.productbrand.clearValidators();
      this.formGroup.controls.productbrand.patchValue('');
    }
    else if (groupValue?.AssetGroupName == 'Products') {
      this.formGroup.controls.product.setValidators([Validators.required]);
      this.formGroup.controls.event.clearValidators();
      this.formGroup.controls.event.patchValue('');
      this.formGroup.controls.offer.clearValidators();
      this.formGroup.controls.offer.patchValue('');
      this.formGroup.controls.promo.clearValidators();
      this.formGroup.controls.promo.patchValue('');
      this.formGroup.controls.version.clearValidators();
      this.formGroup.controls.version.patchValue([]);
      this.formGroup.controls.productbrand.clearValidators();
      this.formGroup.controls.productbrand.patchValue('');
    }
    else if (groupValue?.AssetGroupName == 'Brands') {
      this.formGroup.controls.productbrand.setValidators([Validators.required]);
      this.formGroup.controls.product.clearValidators();
      this.formGroup.controls.product.patchValue('');
      this.formGroup.controls.event.clearValidators();
      this.formGroup.controls.event.patchValue('');
      this.formGroup.controls.offer.clearValidators();
      this.formGroup.controls.offer.patchValue('');
      this.formGroup.controls.promo.clearValidators();
      this.formGroup.controls.promo.patchValue('');
      this.formGroup.controls.version.clearValidators();
      this.formGroup.controls.version.patchValue([]);
    }
    this.formGroup.markAllAsTouched();
  }

  openProductsDialog(): void {
    const dialogRef = this.dialog.open(UploadAssetsProductsComponent, {
      width: '60%',
      height: '90%',
      data: { event: this.selectedProduct }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.formGroup.controls.product.patchValue(res.Detail?.ProductName);
        this.formGroup.markAllAsTouched();
        this.selectedProduct = res;
      }
    });
  }

  openProductBrandsDialog(): void {
    const dialogRef = this.dialog.open(UploadAssetsProductBrandsComponent, {
      width: '60%',
      height: '90%',
      data: { event: this.selectedProductBrand }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        console.log(res);

        this.formGroup.controls.productbrand.patchValue(res.ProductBrandName);
        this.formGroup.markAllAsTouched();
        this.selectedProductBrand = res;
      }
    });
  }
  openOffersDialog(): void {
    const dialogRef = this.dialog.open(UploadAssetsOffersComponent, {
      width: '60%',
      height: '90%',
      data: { event: this.selectedEvent }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.formGroup.controls.offer.patchValue(res.Detail?.Name);
        this.formGroup.markAllAsTouched();
        this.selectedOffer = res;
      }
    });
  }

  openVersionsDialog(): void {
    const dialogRef = this.dialog.open(UploadAssetsVersionsComponent, {
      width: '60%',
      height: '90%',
      data: { event: this.selectedEvent?.Detail.Id, isMultiSelect: this.selectedGroupName?.AssetGroupName == 'Image Maps' ? true : false }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        let versionName: any
        if (Array.isArray(res)) {
          versionName = res.map((x: any) => x.VersionName);
        } else {
          versionName = res.VersionName
        }
        this.formGroup.controls.version.patchValue(versionName);
        this.formGroup.markAllAsTouched();
        if (Array.isArray(res)) {
          //this.selectedVersionId = res.map((x: any) => x.Id);
          this.selectedVersion = res;
        } else {
          this.selectedVersion = [res];
        }

      }
    });
  }

  openPromosDialog(): void {
    const dialogRef = this.dialog.open(UploadAssetsPromosComponent, {
      width: '60%',
      height: '90%',
      data: { event: this.selectedEvent }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.formGroup.controls.promo.patchValue(res.Detail?.Name);
        this.formGroup.markAllAsTouched();
        this.selectedPromo = res;
      }
    });
  }

  openOfferGroupsDialog(): void {
    const dialogRef = this.dialog.open(UploadAssetsOfferGroupsComponent, {
      width: '60%',
      height: '90%',
      data: { event: this.selectedEvent }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.formGroup.controls.offergroup.patchValue(res.Detail?.Name);
        this.formGroup.markAllAsTouched();
        this.selectedOfferGroup = res;
      }
    });
  }

  openEventsialog() {
    const dialogRef = this.dialog.open(UploadAssetsEventsComponent, {
      width: '60%',
      height: '90%',
      data: {
        offerId: this.route.snapshot.params['offerId'],
        includeExpiredEvents: false,
      },
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.formGroup.controls.event.patchValue(res.Detail?.EventName);
        this.formGroup.markAllAsTouched();
        this.selectedEvent = res;
      }
    });
  }

  uploadClose() {
    this.router.navigate([`../`], { relativeTo: this.route });
  }

  done() {
    this.assetsService.reload();
    this.router.navigate([`../`], { relativeTo: this.route });

  }

  tagSelected(tagId: string): void {
    if (this.updatedOfferTagIds?.length > 0 && this.updatedOfferTagIds.includes(tagId)) {
      return;
    }
    this.updatedOfferTagIds.push(tagId);
  }

  addTag(offerTag: OfferTag): void {
    this.updatedOfferTagIds.push(offerTag.Id);
    this.matSnackBar.open(`${offerTag.OfferTagName} saved`, 'OK', DEFAULT_SNACKBAR_CONFIG);
  }

  removeTag(tagId: string): void {
    this.updatedOfferTagIds = this.updatedOfferTagIds.filter(id => id !== tagId);
  }

  compareGroupOption(c1: Group, c2: Group): boolean {
    return c1 && c2 ? c1.Id === c2.Id : c1 === c2;
  }

  selectFiles(event: Event): void {
    this.progressInfos = [];
    const element = event.currentTarget as HTMLInputElement;
    if (element.files) {
      for (let index = 0; index <= element.files.length - 1; index++) {
        if (element.files[index] && element.files[index].name && element.files[index].name.split('.')[0]) {
          const fileName = element.files[index].name.split('.')[0];
          // if (this.hasSpecialChars(fileName)) {
          //   this.matSnackBar.open(
          //     'Special Characters are not allowed', 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
          //   throw new Error('Special Characters are not allowed');
          // }
          if (this.isFileSizeExceeded(element.files[index])) {
            this.matSnackBar.open(
              'File Size has been exceeded', 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
            throw new Error('File Size has been exceeded');
          }
        }
      }
      this.selectedFiles = element.files as any;
    }
  }

  hasSpecialChars(data: string) {
    const specialCharsSet = new Set("!@#$%^&*();{}[]");
    for (let letter of data) {
      if (specialCharsSet.has(letter)) {
        return true;
      }
    }
    return false;
  }

  isFileSizeExceeded(file: any): boolean {
    let fileSize = file.size;
    let type = file.type;
    if (type == "video/mp4" || type == "application/x-zip-compressed") {
      if (fileSize > 256 * 1024 * 1024) {
        return true;
      }
    }
    else {
      if (fileSize > 40 * 1024 * 1024) {
        return true;
      }
    }
    return false;
  }

  uploadFiles(): void {
    if (this.formGroup.valid && this.selectedFiles) {
      this.upload();
    }
  }

  onClear() {
    this.selectedFiles = [];
    this.progressInfos = [];
    this.showButtons = true;
  }

  upload(): void {
    if (this.selectedFiles && this.selectedFiles.length > 0) {
      this.showDone = false;
      for (let index = 0; index <= this.selectedFiles.length - 1; index++) {
        const formGroupData: any = this.formGroup.controls.groupName.value;
        const updatedOfferTagIds = this.updatedOfferTagIds;
        const formData: FormData = new FormData();
        formData.append('File', this.selectedFiles[index]);
        for (let i = 0; i <= updatedOfferTagIds.length - 1; i++) {
          formData.append('offerTagIds', updatedOfferTagIds[i]);
        };
        //formData.append('assetGroup.assetGroupName', formGroupData?.AssetGroupName);
        formData.append('AssetGroupId', formGroupData?.Id);
        formData.append('EventId', this.selectedEvent?.Detail?.Id);
        if (this.selectedOffer?.Detail?.Id)
          formData.append('OfferId', this.selectedOffer?.Detail?.Id);

        if (this.selectedProduct?.Detail?.Id)
          formData.append('ProductId', this.selectedProduct?.Detail?.Id);

        if (this.selectedProductBrand?.Id)
          formData.append('ProductBrandId', this.selectedProductBrand?.Id);

        if (this.selectedPromo?.Detail?.Id)
          formData.append('PromoId', this.selectedPromo?.Detail?.Id);

        if (this.selectedOfferGroup?.Detail?.Id)
          formData.append('OfferGroupId', this.selectedOfferGroup?.Detail?.Id);

        if (this.selectedVersion && this.selectedVersion.length > 0) {
          for (let ai = 0; ai <= this.selectedVersion.length - 1; ai++) {
            formData.append('VersionIds', this.selectedVersion[ai].Id);
          };
        }

        //formData.append('VersionIds', this.selectedVersion && this.selectedVersion[0].Id ? this.selectedVersion[0].Id : (this.selectedVersionId ? this.selectedVersionId : ''));
        //formData.append('assetGroup.id', formGroupData?.Id);

        this.progressInfos[index] = { value: 0, fileName: this.selectedFiles[index].name, status: 'uploading' };
        if (this.selectedFiles[index]) {
          this.assetsService.uploadAsset(formData).subscribe({
            next: (event: any) => {
              if (event.type === HttpEventType.UploadProgress) {
                this.progressInfos[index].value = Math.round(100 * event.loaded / event.total);

              }
              if (index === this.progressInfos.length - 1) {
                this.showDone = true;
                this.showButtons = false;
              }
              this.progressInfos[index].status = 'success';
              this.progressInfos[index].value = 100;
            },
            error: (err: any) => {
              this.progressInfos[index].value = 0;
              this.progressInfos[index].status = 'failure';
              if (err.status === 500) {
                log.error('500 Error uploading Asset', err);
              }
              if (err.status === 400) {
                const apiValidations: any = err.error;
                if (Array.isArray(apiValidations)) {
                  apiValidations.forEach((validation: any) => {
                    if (this.formGroup?.get(validation.PropertyName)) {
                      const control = this.formGroup?.get(validation.PropertyName);
                      if (control) {
                        control.markAsTouched();
                        control.setErrors({ invalid: validation.ErrorMessage });
                        this.matSnackBar.open(validation.ErrorMessage, 'OK', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
                      }
                    } else {
                      this.matSnackBar.open(validation.ErrorMessage, 'OK', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
                    }
                  });
                } else {
                  this.matSnackBar.open(apiValidations, 'Error', { verticalPosition: 'top', panelClass: ['snackbar-error'] });
                }
              }
            }
          });
        }
      }
    }
  }

  isAdmin(): boolean {
    const hasAccess = this.authorizationService.checkAccess('admin||offermang');
    return hasAccess;
  }
}
